import { Divider, Tooltip } from 'antd'
import { isArray, isBoolean, isElement, isEmpty } from 'lodash'
import dayjs from 'dayjs'
import { replaceRule } from '@/utils/data'
import styles from './index.module.less'

const columnMap = {
  dynaOptions: 'ARG',
  materialDynaOptions: 'MATERIAL_DYNA_OPTIONS',
  remark: 'REMARK',
  displayQtyFormular: 'BUDGET_QTY_FORMULAR',
  budgetAmount: 'BUDGET_QTY_AMOUNT',
}

// 通项选材
export const config = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '通项/分类',
      dataIndex: 'name',
      width: 100,
      render: (val, record) => <span
        style={{
          color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
        }}>
          {val}
      </span>
    },
    {
      title: '是否必选',
      name: 'requiredFlag',
      dataIndex: 'requiredFlag',
      width: 100,
      render: 'isRequiredRender',
    },
    {
      title: '产品信息',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '报价属性',
      dataIndex: 'materialDynaOptions',
      width: 250,
      name: 'materialDynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'materialDynaOptions'),
    },
    {
      title: '是否标配',
      dataIndex: 'standardFlag',
      width: 150,
      name: 'standardFlag',
      render: (text: any, record: any) => renderListFn(record, 'standardFlag'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '原预算量',
      dataIndex: 'oldBudgetQtyValue',
      width: 90,
      name: 'oldBudgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'oldBudgetQtyValue'),
    },
    {
      title: '新预算量',
      dataIndex: 'budgetQtyValue',
      width: 90,
      name: 'budgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'budgetQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: '#',
      render: 'actionRender',
      fixed: 'right',
      width: 120,
    },
  ],
  searchMode: 'group',
  // "search": false,
}
// 项目选材
export const projectConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '通项/分类',
      dataIndex: 'name',
      width: 100,
      render: (val, record) => <span
        style={{
          color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
        }}>
          {val}
      </span>
    },
    {
      title: '是否必选',
      name: 'requiredFlag',
      dataIndex: 'requiredFlag',
      width: 100,
      render: 'isRequiredRender',
    },
    {
      title: '产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '报价属性',
      dataIndex: 'materialDynaOptions',
      width: 250,
      name: 'materialDynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'materialDynaOptions'),
    },
    {
      title: '是否标配',
      dataIndex: 'standardFlag',
      width: 150,
      name: 'standardFlag',
      render: (text: any, record: any) => renderListFn(record, 'standardFlag'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '原预算量',
      dataIndex: 'oldBudgetQtyValue',
      width: 90,
      name: 'oldBudgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'oldBudgetQtyValue'),
    },
    {
      title: '新预算量',
      dataIndex: 'budgetQtyValue',
      width: 90,
      name: 'budgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'budgetQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: '#',
      render: 'actionRender',
      fixed: 'right',
      width: 120,
    },
  ],
  searchMode: 'group',
  // "search": false,
}
// 增项选材
export const addConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '类型',
      dataIndex: 'sourceType',
      width: 100,
      render: (text: any, record: any) => {
        return <span
        style={{
          color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
        }}
        >{record.sourceType === 'PRODUCT' ? '产品' : '通项'}</span>
      },
    },
    {
      title: '产品分类',
      dataIndex: 'name',
      width: 100,
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
      }}>
        {val}
      </span>
    },
    {
      title: '产品信息',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '报价属性',
      dataIndex: 'materialDynaOptions',
      width: 250,
      name: 'materialDynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'materialDynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '原预算量',
      dataIndex: 'oldBudgetQtyValue',
      width: 90,
      name: 'oldBudgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'oldBudgetQtyValue'),
    },
    {
      title: '新预算量',
      dataIndex: 'budgetQtyValue',
      width: 90,
      name: 'budgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'budgetQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '添加位置',
      dataIndex: 'spaceName',
      width: 90,
      name: 'spaceName',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: '#',
      render: 'actionRender',
      fixed: 'right',
      width: 120,
    },
  ],
  searchMode: 'group',
  // "search": false,
}
// 减项选材
export const subConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '类型',
      dataIndex: 'prdCateName',
      width: 100,
      render: (text: any, record: any) => {
        return <span
        style={{
          color: record?.updateType === 'ADD' ?
          'green' : (record?.updateType === 'REMOVE'
            || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['prdCateName']))
          ) ?
          'red' : '#333'
        }}
        > {record?.generalItemManageId ? '通项' : '产品'}
        </span>
      },
    },
    {
      title: '名称',
      dataIndex: 'name',
      width: 280,
      name: 'name',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      render: (text: any, record: any) => {
        if (record?.dynaOptions && Object.keys(record?.dynaOptions).length) {
          const strings: string[] = []
          for (let key in record.dynaOptions) {
            strings.push(
              `${record.dynaOptions[key]?.argName}：${record.dynaOptions[key]?.valueName}`
            )
          }
          text = strings.map((str: string) => <div key={str}>{str}</div>)
          return <div
            style={{
              color: record?.updateType === 'ADD' ?
              'green' : (record?.updateType === 'REMOVE'
                || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['dynaOptions']))
              ) ?
              'red' : '#333'
            }}
          >
            {
              (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['dynaOptions'])) ? (<div>
                <div className={styles.ellipsisBox}>
                  <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['dynaOptions'])?.valueOld} placement="topLeft" autoAdjustOverflow>
                    <div>原：{record?.updateFields?.find(field => field.fieldEnum === columnMap['dynaOptions'])?.valueOld}</div>
                  </Tooltip>
                </div>
                <div className={styles.ellipsisBox}>
                  <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['dynaOptions'])?.valueNew} placement="topLeft" autoAdjustOverflow>
                    <div style={{ marginTop: '8px' }}>新：{record?.updateFields?.find(field => field.fieldEnum === columnMap['dynaOptions'])?.valueNew}</div>
                  </Tooltip>
                </div>
              </div>) : text
            }
          </div>
        } else {
          return <span></span>
        }
      },
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => {
        return <span
        style={{
          color: record?.updateType === 'ADD' ?
          'green' : (record?.updateType === 'REMOVE'
            || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['prdUnit']))
          ) ?
          'red' : '#333'
        }}
        > {text ? text : '-'}</span>
      },
    },
    {
      title: '单价',
      dataIndex: 'displayCustPrice',
      width: 120,
      name: 'displayCustPrice',
      align: 'left',
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['displayCustPrice']))
        ) ?
        'red' : '#333'
      }}>
        {val}
      </span>
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['displayQtyFormular']))
        ) ?
        'red' : '#333'
      }}>
        {
          (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['displayQtyFormular'])) ? (<div>
            <div className={styles.ellipsisBox}>
              <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['displayQtyFormular'])?.valueOld} placement="topLeft" autoAdjustOverflow>
                <div>原：{record?.updateFields?.find(field => field.fieldEnum === columnMap['displayQtyFormular'])?.valueOld}</div>
              </Tooltip>
            </div>
            <div className={styles.ellipsisBox}>
              <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['displayQtyFormular'])?.valueNew} placement="topLeft" autoAdjustOverflow>
                <div style={{ marginTop: '8px' }}>新：{record?.updateFields?.find(field => field.fieldEnum === columnMap['displayQtyFormular'])?.valueNew}</div>
              </Tooltip>
            </div>
          </div>) : val
        }
      </span>
    },
    {
      title: '原预算量',
      dataIndex: 'oldBudgetQtyValue',
      width: 90,
      name: 'oldBudgetQtyValue',
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['oldBudgetQtyValue']))
        ) ?
        'red' : '#333'
      }}>
        {val || '-'}
      </span>
    },
    {
      title: '新预算量',
      dataIndex: 'budgetQtyValue',
      width: 90,
      name: 'budgetQtyValue',
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetQtyValue']))
        ) ?
        'red' : '#333'
      }}>
        {val || '-'}
      </span>
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetAmount']))
        ) ?
        'red' : '#333'
      }}>
        {
          (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetAmount'])) ? (<div>
            <div className={styles.ellipsisBox}>
              <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetAmount'])?.valueOld} placement="topLeft" autoAdjustOverflow>
                <div>原：{record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetAmount'])?.valueOld}</div>
              </Tooltip>
            </div>
            <div className={styles.ellipsisBox}>
              <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetAmount'])?.valueNew} placement="topLeft" autoAdjustOverflow>
                <div style={{ marginTop: '8px' }}>新：{record?.updateFields?.find(field => field.fieldEnum === columnMap['budgetAmount'])?.valueNew}</div>
              </Tooltip>
            </div>
          </div>) : val
        }
      </span>
    },
    {
      title: '所在位置',
      dataIndex: 'spaceName',
      width: 100,
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['spaceName']))
        ) ?
        'red' : '#333'
      }}>
        {val}
      </span>
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ?
        'green' : (record?.updateType === 'REMOVE'
          || (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['remark']))
        ) ?
        'red' : '#333'
      }}>
        {
          (record?.updateType === 'UPDATE' && record?.updateFields?.find(field => field.fieldEnum === columnMap['remark'])) ? (<div>
            <div className={styles.ellipsisBox}>
              <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['remark'])?.valueOld} placement="topLeft" autoAdjustOverflow>
                <div>原：{record?.updateFields?.find(field => field.fieldEnum === columnMap['remark'])?.valueOld}</div>
              </Tooltip>
            </div>
            <div className={styles.ellipsisBox}>
              <Tooltip title={record?.updateFields?.find(field => field.fieldEnum === columnMap['remark'])?.valueNew} placement="topLeft" autoAdjustOverflow>
                <div style={{ marginTop: '8px' }}>新：{record?.updateFields?.find(field => field.fieldEnum === columnMap['remark'])?.valueNew}</div>
              </Tooltip>
            </div>
          </div>) : val
        }
      </span>
    },
    {
      title: '操作',
      dataIndex: '#',
      render: 'actionRender',
      fixed: 'right',
      width: 120,
    },
  ],
  searchMode: 'group',
  // "search": false,
}
// 活动选材
export const disconutConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '活动名称',
      dataIndex: 'name',
      width: 100,
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
      }}>
        {val}
      </span>
    },
    {
      title: '产品信息',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '报价属性',
      dataIndex: 'materialDynaOptions',
      width: 250,
      name: 'materialDynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'materialDynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '原预算量',
      dataIndex: 'oldBudgetQtyValue',
      width: 90,
      name: 'oldBudgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'oldBudgetQtyValue'),
    },
    {
      title: '新预算量',
      dataIndex: 'budgetQtyValue',
      width: 90,
      name: 'budgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'budgetQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '添加位置',
      dataIndex: 'spaceName',
      width: 90,
      name: 'spaceName',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },

  ],
  searchMode: 'group',
}
// 升降级选材
export const uporDownConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '通项',
      dataIndex: 'name',
      width: 100,
      render: (val, record) => <span
      style={{
        color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
      }}>
        {val}
      </span>
    },
    {
      title: '产品信息',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '报价属性',
      dataIndex: 'materialDynaOptions',
      width: 250,
      name: 'materialDynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'materialDynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '原预算量',
      dataIndex: 'oldBudgetQtyValue',
      width: 90,
      name: 'oldBudgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'oldBudgetQtyValue'),
    },
    {
      title: '新预算量',
      dataIndex: 'budgetQtyValue',
      width: 90,
      name: 'budgetQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'budgetQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '所在位置',
      dataIndex: 'spaceName',
      width: 100,
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
  ],
  searchMode: 'group',
  // "search": false,
}
// 缺断货选材
export const shortageConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80,
      render: 'DragHandle',
    },
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 100,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '类型',
      dataIndex: 'sourceRefType',
      width: 100,
      // render: 'typeRender',
      render: (text: any, record: any) => {
        record.tableConfigType = 'shortageConfig'
        return renderListFn(record, 'sourceRefType')
      },
    },
    {
      title: '缺断货产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 250,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '添加位置',
      dataIndex: 'spaceName',
      width: 90,
      name: 'spaceName',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
      // render:'displayQtyValueRender'
      render: (text: any, record: any) => {
        record.tableConfigType = 'shortageConfig'
        return renderListFn(record, 'displayQtyValue')
      },
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 150,
      name: 'budgetAmount',
      // render:'budgetAmountRender'
      render: (text: any, record: any) => {
        record.tableConfigType = 'shortageConfig'
        return renderListFn(record, 'budgetAmount')
      },
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
  ],
  searchMode: 'group',
  footer: [],
}
export const renderListFn = (
  record: any,
  dataIndex: string,
  nodeRenderFn?: any,
  itemType?: any
) => {
  const list = record?.budgetDtlVoList || []

  return !!list?.length ? (
    <div>
      {list.map((item, index) => {
        let text: any = item?.[dataIndex]
        if (!!text && itemType == 'dateTime') {
          text = dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        }
        if (!!text && itemType == 'date') {
          text = dayjs(text).format('YYYY-MM-DD')
        }
        if (dataIndex.includes('Flag')) {
          if (isBoolean(text)) {
            text = text ? '是' : '否'
          }
          text = text == '1' ? '是' : text == '0' ? '否' : text
        }
        if (dataIndex === 'dynaOptions') {
          if (text && Object.keys(text).length) {
            const strings: string[] = []
            for (let key in text) {
              strings.push(`${text[key].argName}：${text[key].valueName}`)
            }
            text = strings.map((str: string) => <div key={str}>{str}</div>)
          } else {
            text = <span></span>
          }
        }
        if (dataIndex === 'oldBudgetQtyValue' || dataIndex === 'budgetQtyValue') {
          if (!text) {
            text = '-'
          }
        }
        if (dataIndex === 'materialDynaOptions') {
          if (text && Object.keys(text).length) {
            const strings: string[] = []
            for (let key in text) {
              strings.push(`${text[key].name}：${text[key].optionName}`)
            }
            text = strings.map((str: string) => <div key={str}>{str}</div>)
          } else {
            text = <span></span>
          }
        }
        if (dataIndex === 'displayQtyFormular') {
          if (text) {
            text = replaceRule(text)
          }
        }

        // 缺断货选材单独处理
        if (
          record.tableConfigType === 'shortageConfig' &&
          (dataIndex === 'displayQtyValue' || dataIndex === 'budgetAmount')
        ) {
          text = text < 0 ? -1 * text : text
        }
        if (record.tableConfigType === 'shortageConfig' && dataIndex === 'sourceRefType') {
          let typeName = {
            ADD: '增项',
            ACTIVITY: '优惠',
            GENERAL: '通项选材',
            PROJECT: '项目选材',
            SUB: '减项',
            UP_DOWN: '升降级',
          }
          text = typeName[text] ? typeName[text] : '其他'
        }

        return (
          <div
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            {index != 0 && (
              <Divider
                style={{ margin: '4px 0', borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)' }}
              />
            )}
            <div
              style={{
                minHeight: '76px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                lineHeight: '18px',
                color:
                  item?.updateType === 'ADD' ?
                  'green' : (item?.updateType === 'REMOVE'
                    || (item?.updateType === 'UPDATE' && item?.updateFields?.find(field => field.fieldEnum === columnMap[dataIndex]))
                  ) ?
                  'red' : '#333'
              }}
            >
              {
                nodeRenderFn?.(item) || (
                  (item?.updateType === 'UPDATE' && item?.updateFields?.find(field => field.fieldEnum === columnMap[dataIndex])) ? (<div>
                    <div className={styles.ellipsisBox}>
                      <Tooltip title={item?.updateFields?.find(field => field.fieldEnum === columnMap[dataIndex])?.valueOld} placement="topLeft" autoAdjustOverflow>
                        <div>原：{item?.updateFields?.find(field => field.fieldEnum === columnMap[dataIndex])?.valueOld}</div>
                      </Tooltip>
                    </div>
                    <div className={styles.ellipsisBox}>
                      <Tooltip title={item?.updateFields?.find(field => field.fieldEnum === columnMap[dataIndex])?.valueNew} placement="topLeft" autoAdjustOverflow>
                        <div style={{ marginTop: '8px' }}>新：{item?.updateFields?.find(field => field.fieldEnum === columnMap[dataIndex])?.valueNew}</div>
                      </Tooltip>
                    </div>
                  </div>) : text
                )
              }
            </div>
          </div>
        )
      })}
    </div>
  ) : (
    record[dataIndex]
  )
}
